module.exports = {
    labels: {
        success: "Sucesso",
        warning: "Aviso",
        alert: "Erro",
        info: "Info",
        confirm: "É necessário confirmar"
    },
    modal: {
      confirm: "É necessário confirmar",
      okLabel: "Sim",
      cancelLabel: "Não"
    },
    position: "top-right",
    animationDuration: 200,
    maxNotifications: 5
}
// .info .success .warning .alert